var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGenericError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-147"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.6,
    y: 101.8,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.58,
    y: 101.8,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.57,
    y: 101.8,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.07,
    y: 101.8,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.05,
    y: 101.8,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.03,
    y: 101.8,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.01,
    y: 101.8,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.98,
    y: 237.02,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.96,
    y: 237.02,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.94,
    y: 237.02,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.49,
    y: 223.81,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.47,
    y: 223.81,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.45,
    y: 223.81,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.43,
    y: 223.81,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 210.61,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.98,
    y: 210.61,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.96,
    y: 210.61,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.94,
    y: 210.61,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.93,
    y: 210.61,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.49,
    y: 197.4,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.47,
    y: 197.4,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.45,
    y: 197.4,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.43,
    y: 197.4,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.68,
    y: 371.57,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.66,
    y: 371.57,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.19,
    y: 358.36,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.17,
    y: 358.36,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.13,
    y: 358.36,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.11,
    y: 358.36,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.66,
    y: 345.16,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.05,
    y: 294.27,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.03,
    y: 294.27,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.56,
    y: 281.06,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.54,
    y: 281.06,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.76,
    y: 307.6,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.75,
    y: 307.6,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.27,
    y: 294.39,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.25,
    y: 294.39,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.05,
    y: 267.86,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.03,
    y: 267.86,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.62,
    y: 345.16,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.7,
    y: 371.22,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.69,
    y: 371.22,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.19,
    y: 358.01,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.57,
    y: 371.01,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.55,
    y: 371.01,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.08,
    y: 357.8,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.06,
    y: 357.8,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.04,
    y: 357.8,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.59,
    y: 344.59,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.57,
    y: 344.59,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.55,
    y: 344.59,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.08,
    y: 331.39,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.06,
    y: 331.39,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.44,
    y: 240.61,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.42,
    y: 240.61,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.98,
    y: 239.4,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.95,
    y: 227.4,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.93,
    y: 227.4,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.49,
    y: 226.19,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.47,
    y: 226.19,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.87,
    y: 268.89,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.76,
    y: 275.18,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.28,
    y: 315.73,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.36,
    y: 282.1,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.38,
    y: 282.1,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.09,
    y: 101.8,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.6,
    y: 115.01,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.44,
    y: 214.19,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.42,
    y: 214.19,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.95,
    y: 200.99,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.93,
    y: 200.99,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.09,
    y: 164.45,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.08,
    y: 164.45,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.06,
    y: 164.45,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.04,
    y: 164.45,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.6,
    y: 128.23,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.58,
    y: 151.25,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.55,
    y: 151.25,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.11,
    y: 115.02,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.09,
    y: 115.02,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.08,
    y: 138.04,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.56,
    y: 165.06,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.54,
    y: 165.06,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.52,
    y: 165.06,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.07,
    y: 151.86,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.05,
    y: 128.84,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.03,
    y: 128.84,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.01,
    y: 151.86,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.58,
    y: 138.65,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.56,
    y: 138.65,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.54,
    y: 115.63,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.52,
    y: 115.63,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.44,
    y: 135.81,
    width: 351.78,
    height: 15,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.24,
    y: 134.23,
    width: 3.44,
    height: 18.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.97,
    y: 134.23,
    width: 3.44,
    height: 18.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.71,
    y: 134.23,
    width: 3.44,
    height: 18.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.44,
    y: 134.23,
    width: 3.44,
    height: 18.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.44,
    y: 165.81,
    width: 351.78,
    height: 15,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.24,
    y: 164.23,
    width: 3.44,
    height: 18.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.97,
    y: 164.23,
    width: 3.44,
    height: 18.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.71,
    y: 164.23,
    width: 3.44,
    height: 18.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.44,
    y: 164.23,
    width: 3.44,
    height: 18.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.44,196.81v15H324.06a23.81,23.81,0,0,1,23.8,23.81V358.24h15V235.42a38.61,38.61,0,0,0-38.61-38.61Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.97,
    y: 195.23,
    width: 3.44,
    height: 18.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.71,
    y: 195.23,
    width: 3.44,
    height: 18.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.44,
    y: 195.23,
    width: 3.44,
    height: 18.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.64,
    y: 347.89,
    width: 3.44,
    height: 18.17,
    transform: "translate(712.33 1.61) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.64,
    y: 242.62,
    width: 3.44,
    height: 18.17,
    transform: "translate(607.07 -103.65) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-147"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-147",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--light-bulb--inject-147"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.88,282.33,73.41,293.47l.33-1a108.92,108.92,0,0,1,11.19-22.88l18.34-6-2,25.27,2,0-4.42,10.57-1.34-6.06L85.12,301.1Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.27,288.91l2,0-4.42,10.58-1.34-6.07L85.12,301.1l.75-18.77L73.41,293.47l.33-1A109.74,109.74,0,0,1,84.93,269.6l18.35-6Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.55,389l-8.93,7.27a96.79,96.79,0,0,1-21.18-30l2-14.48,8.91,11.47Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.55,389l-8.93,7.28a97,97,0,0,1-21.18-30l2-14.47,8.92,11.46Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.04 384.06 232.03 384.06 231.99 384.09 207.5 402.03 184.11 402.86 176.78 385.04 176.77 385.04 162.37 393.04 158.6 381.56 158.58 381.53 174.11 363.07 176.88 344.96 189.64 339.2 210.76 345.46 210.77 345.46 216.42 359.92 230.04 364.33 230.05 364.34 226.09 372.06 232.03 384.04 232.04 384.06",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.03 384.06 231.99 384.09 207.51 402.03 184.1 402.86 176.78 385.04 162.37 393.04 158.58 381.53 174.1 363.07 176.88 344.96 189.65 339.2 210.76 345.46 216.41 359.92 230.05 364.33 226.09 372.06 232.02 384.05 232.03 384.06",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.19 281.96 279.35 277.02 270.78 254.38 297.34 254.28 306.47 273.45 291.19 281.96",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.34 254.28 306.48 273.45 291.19 281.96 288.01 280.64 279.35 277.02 270.78 254.38 297.34 254.28",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.44,271.53l-6.73,14.58,7.16-3.78L73.41,293.47l.33-1A109.74,109.74,0,0,1,84.93,269.6l18.35-6Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.55,389l-8.93,7.28a97,97,0,0,1-21.18-30l2-14.47.68,14.76s9,18.94,18.92,28.48Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.03 384.04 232.02 384.05 231.99 384.09 207.5 402.03 184.11 402.86 184.1 402.86 176.77 385.04 162.37 393.04 162.36 393.04 158.57 381.53 158.6 381.56 163.56 389.43 176.95 381.95 181.37 374.89 179.48 383.43 185.52 400.31 206.13 400.73 227.41 383.35 222.69 370.89 230.04 364.33 230.05 364.34 226.09 372.06 232.03 384.04",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.34,254.28l9.13,19.17L291.19,282,288,280.64,302.27,273l-2.83-6.69-12.54-2.12c.64,0,10.73,0,11.13-.4S297.34,254.28,297.34,254.28Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.79,352.92c-.14,1.11-.29,2.22-.47,3.32-.41,2.74-.93,5.43-1.56,8.1-.3,1.29-.63,2.57-1,3.82q-1,3.81-2.34,7.48c-.43,1.23-.9,2.44-1.37,3.64s-1,2.4-1.5,3.59c-.78,1.77-1.61,3.51-2.48,5.24-.21.39-.42.8-.64,1.2l-12.14-27.79,6.47-20.92L357,328.08h0A108.5,108.5,0,0,1,356.79,352.92Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.79,352.92c-.14,1.1-.29,2.21-.47,3.32-.4,2.73-.93,5.43-1.56,8.1-.3,1.29-.62,2.56-1,3.82q-1.05,3.79-2.34,7.47c-.44,1.23-.9,2.45-1.38,3.65s-1,2.4-1.5,3.58c-.78,1.78-1.61,3.52-2.48,5.24-.2.4-.41.8-.64,1.2l-12.14-27.78,6.47-20.92L357,328.08h0A109.06,109.06,0,0,1,356.79,352.92Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.79,352.92c-.14,1.1-.29,2.21-.47,3.32-.4,2.73-.93,5.43-1.56,8.1-.3,1.29-.62,2.56-1,3.82q-1.05,3.79-2.34,7.47c-.44,1.23-.9,2.45-1.38,3.65s-1,2.4-1.5,3.58c-.78,1.78-1.61,3.52-2.48,5.24-.2.4-.41.8-.64,1.2l-12.14-27.78,10.34,18.9,6.12-14.54L345,356.6l6.39,6c3.93-12.06,5.63-34.56,5.63-34.56h0A109.06,109.06,0,0,1,356.79,352.92Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.97 323.31 125.14 336.39 142.94 333.8 158.09 353.5 169.23 345.1 171.68 334.26 194.11 335.82 203.86 341.06 221.02 342.73 224.43 331.85 246.71 325.63 259.05 335.77 273.13 305.79 228.37 261.71 116.97 323.31",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.13 305.79 266.15 320.65 259.05 335.77 246.71 325.62 224.42 331.85 221.02 342.74 203.86 341.06 194.11 335.82 171.68 334.26 169.23 345.11 158.09 353.5 142.94 333.8 125.14 336.39 116.97 323.3 117.72 322.89 120.83 321.18 228.37 261.71 271.53 304.21 273.13 305.79",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.53,304.21c-14,9.31-37.86,21.78-68.09,24.78-34.3,3.39-66.17-3.33-82.61-7.81l107.54-59.47Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.15 320.65 259.05 335.77 246.71 325.62 224.42 331.85 221.02 342.74 203.86 341.06 194.11 335.82 171.68 334.26 169.23 345.11 158.09 353.5 142.94 333.8 145.66 333.67 157.57 350.56 167.56 344.16 170.4 332.54 168.5 329.2 172.57 332.44 193.8 333.25 197.12 327.89 195.91 333.45 203.58 339.34 219.28 340.35 222.25 331.95 216.69 318.74 224.12 329.03 246.42 323.52 248.44 315.7 248.04 324.24 257.52 332.32 265.47 320.07 266.15 320.65",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.94 334.57 142.94 333.8 125.14 336.39 116.97 323.3 117.72 322.89 125.94 334.57",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.83,178.37c-3.77-11.12-20.3-14.47-36.91-7.48s-27,21.67-23.26,32.79,20.3,14.47,36.91,7.48S188.6,189.49,184.83,178.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.89,210a10.13,10.13,0,0,1,5,5.5c3.7,10.92-13.79,28.4-39.08,39S127,264.93,123.29,254a11.74,11.74,0,0,1,.45-7.78,8.58,8.58,0,0,1-1.95-3.16,11.34,11.34,0,0,1,.53-7.71,8.2,8.2,0,0,1-2-3.23,11.06,11.06,0,0,1,.62-7.69,8.11,8.11,0,0,1-2.13-3.24,10.76,10.76,0,0,1,.73-7.69,7.75,7.75,0,0,1-2.23-3.25c-3.08-9.08,11.47-23.61,32.49-32.45s40.55-8.65,43.63.43a8.56,8.56,0,0,1,.26,4.08,9.19,9.19,0,0,1,5.1,5.23,8.93,8.93,0,0,1,.33,4,9.43,9.43,0,0,1,5,5.31,9.08,9.08,0,0,1,.39,3.91,9.85,9.85,0,0,1,5,5.4A9.45,9.45,0,0,1,209.89,210Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.89,210a10.13,10.13,0,0,1,5,5.5c3.7,10.92-13.79,28.4-39.08,39S127,264.93,123.29,254a11.74,11.74,0,0,1,.45-7.78,8.58,8.58,0,0,1-1.95-3.16,11.34,11.34,0,0,1,.53-7.71,8.2,8.2,0,0,1-2-3.23,11.06,11.06,0,0,1,.62-7.69,8.11,8.11,0,0,1-2.13-3.24,10.76,10.76,0,0,1,.73-7.69,7.75,7.75,0,0,1-2.23-3.25c-3.08-9.08,11.47-23.61,32.49-32.45s40.55-8.65,43.63.43a8.56,8.56,0,0,1,.26,4.08,9.19,9.19,0,0,1,5.1,5.23,8.93,8.93,0,0,1,.33,4,9.43,9.43,0,0,1,5,5.31,9.08,9.08,0,0,1,.39,3.91,9.85,9.85,0,0,1,5,5.4A9.45,9.45,0,0,1,209.89,210Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,315l-18.12,13.19-21.5-19.66L235.49,333,196,319.2l-7.87,22.58-24.73-19.89-25.56,20.85-14.77-20.61-10.17,16.41a107.78,107.78,0,0,1,10.46-62.47,17.87,17.87,0,0,0,.5-15.11,4.81,4.81,0,0,1-.29-.71,9.48,9.48,0,0,1-.49-2.65c0-.26,0-.51,0-.77v-.06c0-.22,0-.44,0-.65l0-.23c0-.24.06-.49.1-.74s.1-.56.17-.84a19.48,19.48,0,0,1,2.06-5.17.36.36,0,0,0,0-.09c.41-.73.87-1.46,1.36-2.19l.8-1.13c.27-.36.54-.72.83-1.09s.53-.66.82-1c.09-.13.19-.24.29-.36l.78-.88a63.06,63.06,0,0,1,6.52-6.2c.24-.21.49-.41.74-.61,1.33-1.09,2.74-2.15,4.22-3.21l1.45-1,.09-.05c1-.7,2-1.38,3.12-2,.58-.37,1.19-.74,1.79-1.1s.93-.56,1.41-.83a3.37,3.37,0,0,1,.32-.19c.53-.31,1.08-.62,1.63-.92.74-.42,1.5-.82,2.27-1.23l1.53-.79.25-.13,1.63-.8c.64-.32,1.28-.62,1.94-.92l1.75-.8.21-.09,2-.86c13.81-5.81,27.1-8.43,37-7.87l.81,0c.54,0,1.07.08,1.58.15l.77.1.74.11c.16,0,.32,0,.47.07l.55.11c.14,0,.29,0,.43.09,4,.82,7.12,2.35,9.09,4.58l.24.27c.14.18.28.35.4.54l0,0a3.62,3.62,0,0,1,.22.32,2.14,2.14,0,0,1,.2.32l.24.44.21.44c.11.24.21.5.3.76a6.05,6.05,0,0,1,.2.73,15.81,15.81,0,0,0,9.48,11c23.74,9.24,43.88,29.88,53.56,58.42A108.31,108.31,0,0,1,285,315Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,315l-18.12,13.19-21.5-19.66L235.49,333,196,319.2l-7.87,22.58-24.73-19.89-25.56,20.85-14.77-20.61-10.17,16.41a107.78,107.78,0,0,1,10.46-62.47,17.87,17.87,0,0,0,.5-15.11,4.81,4.81,0,0,1-.29-.71,9.48,9.48,0,0,1-.49-2.65c0-.26,0-.51,0-.77v-.06c0-.22,0-.44,0-.65l0-.23c0-.24.06-.49.1-.74s.1-.56.17-.84a20,20,0,0,1,2.06-5.17.36.36,0,0,0,0-.09c.42-.72.87-1.46,1.36-2.19l.8-1.13c.27-.36.54-.72.83-1.09s.53-.66.82-1c.09-.13.19-.24.29-.36l.78-.88a63.06,63.06,0,0,1,6.52-6.2c.24-.21.49-.41.74-.61,1.33-1.09,2.74-2.15,4.22-3.21l1.45-1,.09-.05c1-.7,2-1.38,3.12-2,.58-.37,1.19-.74,1.79-1.1s.93-.56,1.41-.83a3.37,3.37,0,0,1,.32-.19c.53-.31,1.08-.62,1.63-.92.74-.42,1.5-.82,2.27-1.23l1.53-.79.25-.13,1.63-.8c.64-.32,1.28-.62,1.94-.92l1.75-.8.21-.09,2-.86c13.81-5.81,27.1-8.43,37-7.87l.81,0c.54,0,1.07.08,1.58.15l.77.1.74.11c.16,0,.32,0,.47.07l.55.11c.14,0,.29,0,.43.09,4,.82,7.12,2.35,9.09,4.58l.24.27c.14.18.28.35.4.54l0,0a3.62,3.62,0,0,1,.22.32,2.14,2.14,0,0,1,.2.32l.24.44.21.44c.11.24.21.5.3.76a6.05,6.05,0,0,1,.2.73,15.81,15.81,0,0,0,9.48,11c23.74,9.24,43.88,29.88,53.56,58.42A108.31,108.31,0,0,1,285,315Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.34,218.81c-.22,10.89-16.71,26.09-39.56,35.71-25.06,10.54-48.36,10.41-52.38-.21,2.45-10.8,18.39-24.67,39.84-33.7C187,210.64,209.16,210.07,215.34,218.81Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.74,246.23S158,200.32,209.89,210C209.89,210,160.86,193.19,123.74,246.23Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.32,235.36s26.32-39.78,82.19-34.58C204.51,200.78,153.12,187.3,122.32,235.36Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.91,224.44s24-38,78.18-32.88C199.09,191.56,150.45,177.28,120.91,224.44Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.51,213.51s25-37.12,74.15-31.19C193.66,182.32,148.48,169.43,119.51,213.51Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.32,277.3c-16.4-3.23-31.19-23.3-39.15-36.18,9.43-6.51,15.41-13.87,15.53-19.69-4.9-6.91-22.45-6.46-41.23,1.43C147.5,230,134.89,241,133,249.52c2,5.4,10.38,7.37,21.33,5.88,5,28.91-6.44,56-6.57,56.35a1,1,0,0,0,1.3,1.32l14.58-6.13,8.8,10.37a1,1,0,0,0,.81.35,1,1,0,0,0,.24,0,1,1,0,0,0,.71-.84l2.71-23.2,15.72,15.33a1,1,0,0,0,1.7-.64l1.82-25.75,16.57,17.89a1,1,0,0,0,1.08.26,1,1,0,0,0,.65-.91l.46-14.39,14.65-6.17a1,1,0,0,0-.19-1.9Zm-15.83,6.47a1,1,0,0,0-.61.89l-.4,12.6L196,279.47a1,1,0,0,0-1.06-.26,1,1,0,0,0-.67.87L192.43,306,176.8,290.72a1,1,0,0,0-1-.22,1,1,0,0,0-.66.82l-2.68,22.94-7.79-9.18a1,1,0,0,0-1.15-.27l-13.08,5.5c2.63-7.16,10.08-30.52,5.85-55.21a82.59,82.59,0,0,0,18.13-5.41,89.11,89.11,0,0,0,14.08-7.42c7.62,12.4,21.46,31.28,37.52,36.24Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.28,262.19c-4.29-13.11-21.3-18.25-38-11.47s-26.73,22.89-22.43,36,21.3,18.24,38,11.47S216.58,275.3,212.28,262.19Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.89 338.54 122.89 319.87 121.58 310.88 127.74 304.6 122.88 310.82 124.48 319.99 137.88 340.17 162.48 319.64 159.7 307.49 164.52 320.93 187.08 337.92 194.08 317.8 196.97 307.43 189.93 296.21 197.75 305.35 204.55 299.87 198.95 307.34 196.8 316.68 234.2 329.03 243.01 305.33 232.45 295.25 234.12 284.09 234.01 294.59 267.07 324.69 284.95 315 266.83 328.19 245.33 308.53 235.49 333 195.99 319.2 188.12 341.78 163.39 321.89 137.83 342.74 123.06 322.13 112.89 338.54",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.26,418.8h0c-1.36.35-2.75.65-4.15.91-.47.1-.93.18-1.4.26-1.1.19-2.19.36-3.28.51l-1.45.18q-2.91.33-5.83.46c-1,.06-2,.08-2.95.1h-1.47c-1.7,0-3.38-.05-5.08-.16l-1.7-.13c-1.69-.14-3.4-.32-5.09-.56l-1.86-.29c-.61-.1-1.23-.2-1.84-.33l3.42-9.76,11,9.31,8.24-14.56,13.12,9.58Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.26,418.8c-1.37.35-2.76.65-4.16.92-.47.1-.93.18-1.4.26-1.1.19-2.19.36-3.28.51l-1.45.18q-2.91.33-5.83.46c-1,.06-2,.08-2.95.1h-1.47c-1.7,0-3.38-.05-5.08-.16l-1.7-.13c-1.69-.14-3.4-.32-5.09-.56l-1.86-.29c-.61-.1-1.23-.2-1.84-.33l3.42-9.76,11,9.31,8.24-14.56,13.12,9.58Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.65,409.64l4.21,6.49a76.54,76.54,0,0,1-24.74-1.26c-1.46-.31-2.92-.67-4.36-1.07l1.7-3.33Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.86,416.14a76.54,76.54,0,0,1-24.74-1.26c-1.46-.32-2.92-.67-4.36-1.08l1.7-3.33,23.19-.83Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.13,376.39c-.74,1.28-1.51,2.56-2.32,3.81-.68,1.07-1.38,2.12-2.11,3.17h0c-.73,1-1.47,2.06-2.25,3.06-.37.51-.77,1-1.16,1.52-.77,1-1.58,2-2.41,2.91h0c-.61.72-1.25,1.43-1.89,2.12s-1.28,1.39-1.94,2.06-1.17,1.17-1.75,1.75c-.89.86-1.81,1.71-2.73,2.53s-1.87,1.63-2.82,2.41l-1.94,1.54c-.45.34-.9.69-1.37,1-.91.68-1.84,1.34-2.78,2-.47.33-.94.64-1.42,1-1.44.93-2.9,1.81-4.4,2.65a81.14,81.14,0,0,1-14.25,6.33c-.64.21-1.28.42-1.92.61l-1.93.56c-1.28.35-2.57.68-3.86,1-.85.19-1.71.36-2.58.52-.66.13-1.34.25-2,.35l-4.67-7.2,25.79-18.9L253,380.21l3.48-6.81.15.05,11.4-30.89,17.08,4.11Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.13,376.39c-.74,1.28-1.51,2.56-2.31,3.81-.69,1.07-1.4,2.12-2.12,3.17h0c-.73,1-1.48,2.06-2.24,3.06-.38.51-.78,1-1.16,1.52-.8,1-1.6,2-2.41,2.91h0c-.62.72-1.26,1.43-1.9,2.12s-1.28,1.39-1.94,2.06-1.16,1.17-1.75,1.75c-.89.86-1.8,1.71-2.73,2.53s-1.86,1.63-2.82,2.41c-.64.52-1.29,1-1.94,1.54-.44.34-.9.69-1.36,1-.91.68-1.85,1.34-2.79,2-.46.33-.94.64-1.42,1q-2.14,1.39-4.4,2.65a82.08,82.08,0,0,1-14.24,6.32c-.65.22-1.29.42-1.93.62l-1.92.56c-1.29.35-2.58.68-3.86,1-.86.19-1.72.37-2.58.52-.67.13-1.34.25-2,.35l-4.66-7.2,25.78-18.9L253,380.21l3.48-6.81.16.05,11.4-30.89,17.07,4.11Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.26,418.8h0c-1.36.35-2.75.65-4.15.91-.47.1-.93.18-1.4.26-1.1.19-2.19.36-3.28.51l-1.45.18q-2.91.33-5.83.46c-1,.06-2,.08-2.95.1h-1.47c-1.7,0-3.38-.05-5.08-.16l-1.7-.13c-1.69-.14-3.4-.32-5.09-.56l-1.86-.29L129.57,410l8.62,10.45,4.72-.58,5.89-15.12,11.62,11.15Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.86,416.14a76.54,76.54,0,0,1-24.74-1.26c-1.46-.32-2.92-.67-4.36-1.08l1.7-3.33,2.76,2.67s7.64,1.89,21.63,1.73l-1.2-5.23Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.12 362.38 278.5 348 271.31 347.8 256.61 377.51 262.01 391.51 267.59 397.6 270.99 397.44 267.83 402.81 267.66 399.1 261.92 395.48 237.99 412.34 238.3 419.21 233.64 412.01 259.42 393.11 253.03 380.21 256.51 373.4 256.67 373.45 268.07 342.56 285.14 346.67 284.15 350.38 287.12 362.38",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.24 348.39 72.73 330.87 86.87 307.04 113.54 316.07 116.21 323.99 105.31 334.67 109.09 353.39 101.52 374.29 75.71 357.41 75.28 345 86.24 348.39",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.54 316.07 116.22 323.99 105.31 334.67 109.09 353.39 101.52 374.29 75.71 357.42 75.68 356.79 75.28 345 86.24 348.39 72.73 330.87 86.87 307.04 113.54 316.07",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.54,316.07l-.46,7.81-8.89,6.75L94,332.93l9-.3L105.22,349l-3.34-1.82,4,5.86s-6.34,15.53-5.8,16.16-21.49-10.95-24.35-12.45L75.28,345l11,3.39L72.73,330.87,86.87,307Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.74,323.2c.5-.3.87-.46,1-.41S308.44,323,307.74,323.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.4 316.98 275.39 310.21 275.44 303.74 280.75 281.73 308.21 295.35 312.24 307.06 304.87 335.78 295.69 331.54 291.4 316.98",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.24 307.06 304.87 335.77 295.69 331.54 291.4 316.98 275.39 310.2 275.44 303.74 280.76 281.73 308.21 295.35 312.24 307.06",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.87,335.77l-9.18-4.23L291.4,317l-16-6.78.05-6.47,5.32-22-2.56,20.71,2.07,6.89,12.75,5.4s4.05-1,6-1.53c-1.6,1-4.45,3.31-4.32,5,.16,2.24,3,11.36,3,11.36Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-147"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "344.19 122.08 354.61 107.61 337.81 107.53 330.31 88.51 319.89 102.98 302.31 94.2 309.02 114.48 292.32 126.6 311.95 132.41 308.02 146.2 328.57 142.08 331.71 149.49 337.08 139.35 354.63 156.74 341.82 135.84 353.43 131.47 344.19 122.08",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(-0.99, 0.11, 0.11, 0.99, 330.68, 133.01)",
    style: {
      fontSize: "31.10633087158203px",
      fill: "#fff",
      fontFamily: "MyriadPro-Regular, Myriad Pro"
    }
  }, "!")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-147"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-147"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.27,161.7l-.2,2.52a2.91,2.91,0,0,1-1.42,2.28l-3.8,2.28a5.47,5.47,0,0,1-5,.32l-1-.44c.05-4.2,3.19-8.69,3.19-8.69l.75-1.39a2.43,2.43,0,0,1,3.31-1.05l2.76,1.45A2.83,2.83,0,0,1,339.27,161.7Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.19,208.39c-8.38-5-15.95-11.38-21.53-19.49-5.81-10.11,14.06-21.2,21.27-25a2.56,2.56,0,0,1,2.8,4.22c-3.52,3-7.14,6.16-10.38,9.42-2.12,2.2-4.42,4.51-5.54,7.08-.28.85.12.37-.17-.32l-.48-.85a52.8,52.8,0,0,0,4.16,4.49,103,103,0,0,0,15.07,11.59c5.66,3.64.72,12-5.2,8.83Z",
    style: {
      fill: "#e9b376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.17,196.1l-13.26-9.87s-6.13,9.37-5.55,16.71l17.8,14.23a24.48,24.48,0,0,0,5.41-8.23C342.45,204,336.17,196.1,336.17,196.1Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298.7 398.58 303.44 416.53 310.57 416.53 306.87 396.51 298.7 398.58",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.08 397.96 386.34 415.77 393.46 415.56 389.2 395.65 381.08 397.96",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.54,196.21s-12.17,33.59-9.48,61.66l37.36,6.64c1.33-6,.84-25.82,11.66-53.08,0,0-9.73-3.48-20.89-6.66A81,81,0,0,1,336.54,196.21Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.54,196.21s-12.17,33.59-9.48,61.66l37.36,6.64c1.33-6,.84-25.82,11.66-53.08,0,0-9.73-3.48-20.89-6.66A81,81,0,0,1,336.54,196.21Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.65,412.5l9.15.15a.65.65,0,0,1,.64.52l1.38,6.73a1.12,1.12,0,0,1-.88,1.31l-.25,0c-3-.1-5.11-.31-8.83-.37-2.29,0-9.2.09-12.36,0s-3.53-3.18-2.23-3.44c5.83-1.18,10.23-2.86,12.11-4.5A1.86,1.86,0,0,1,384.65,412.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.53,261.76l-.29,13c3.12,12.86,7.58,52.62,8.51,60.3,1.77,14.6,19.71,69.12,19.71,69.12l-12.69,3.54s-24-48-28.17-61.6-11.51-47.63-11.51-47.63-32.59,38.3-37.81,45.84,7.12,59.44,7.12,59.44l-12.72,3s-18.29-46.85-15.78-66,36.8-62.16,37.54-64.42c.64-1.93,3.93-9.77,5.72-13.76l.92-6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.28,412.5l9.15.15a.65.65,0,0,1,.64.52l1.38,6.73a1.12,1.12,0,0,1-.88,1.31l-.25,0c-3-.1-5.11-.31-8.83-.37-2.29,0-9.2.09-12.36,0s-3.52-3.18-2.23-3.44c5.83-1.18,10.23-2.86,12.11-4.5A1.86,1.86,0,0,1,301.28,412.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.28,310.06a141.85,141.85,0,0,0,3.63-15.2c-9.78-7.58-8.67-16.43-8.67-16.43,4.29,5.05,14,7.07,14,7.07l.84,13S336.9,303.4,331.28,310.06Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.38 266.44 363.98 262.12 327.35 257.67 325.78 261.73 363.38 266.44",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.38 266.44 363.98 262.12 327.35 257.67 325.78 261.73 363.38 266.44",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338,259.23l-.52,3.87a.56.56,0,0,1-.6.5l-5.57-.9a.5.5,0,0,1-.39-.55l.31-3.89a.55.55,0,0,1,.6-.53l5.78.91A.5.5,0,0,1,338,259.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.45 259.99 344.56 265.13 346.25 265.65 347.1 260.18 345.45 259.99",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.02 261.67 359.55 266.84 360.75 267.21 361.19 261.8 360.02 261.67",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.32 257.54 328.08 262.49 327 262.52 328 257.19 329.32 257.54",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.83,198a16.51,16.51,0,0,0,7.84,3.58c4.8.79,10.2,1.29,10.2,1.29s-6.13,9.27-16,6.17S349.83,198,349.83,198Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.83,198a16.51,16.51,0,0,0,7.84,3.58c4.8.79,10.2,1.29,10.2,1.29s-6.13,9.27-16,6.17S349.83,198,349.83,198Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.49,202.39a7.45,7.45,0,0,0,1.18,3.55c-2.8.6-6.66,1.79-9.77,2.82a5.24,5.24,0,0,1-6.95-5.24,4.63,4.63,0,0,1,.16-.87c5.65-.21,6.77-3.89,6.77-7.82,0-.4,0-.8,0-1.2L365.75,187C364.11,191,362,197.61,362.49,202.39Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.93,208.14s9.61-5.06,14.89-5.39,6,4,6,4,2.81-.47,1.73,2.75-23.26.38-23.26.38-9.36-4.84-9.42-10.13,4.61-1.83,4.61-1.83,3-1.11,3.95.08S351.93,208.14,351.93,208.14Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.81,206.76s-11.17,3.72-13.52,2.43S372.81,206.76,372.81,206.76Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.47,197.93a7.37,7.37,0,0,0-.09,4.39c.75,2-1.58,0-1.8-2.27A1.77,1.77,0,0,1,346.47,197.93Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.49,202.39c-5,.48-7.59-4.72-8.61-7.56,0-.4,0-.8,0-1.2L365.75,187C364.11,191,362,197.61,362.49,202.39Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.21,173c5.09,3.28.69,15.39-2,16.2C366.21,190.69,366.9,168.9,373.21,173Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.59,180.4c-.82,7.32-1.68,11.57,1.33,15.93,4.53,6.56,14.05,4.8,17.05-2.13,2.69-6.24,3.59-17.17-3-21.29A10,10,0,0,0,353.59,180.4Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.71,173.68c-.92,4.23,1.9,16.42,5,16.68s5.14-6.19,4.66-12.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.92,187.81a7,7,0,0,0,3.77,3.8c2.27.94,3.69-1,3.3-3.32-.35-2.07-2-5-4.36-5A3.14,3.14,0,0,0,348.92,187.81Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.9,185.51c-.11.59.12,1.13.51,1.19s.78-.35.88-.94-.12-1.13-.51-1.19S371,184.92,370.9,185.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.72,185.44a21.47,21.47,0,0,0,1.94,5.53,3.43,3.43,0,0,1-2.91,0Z",
    style: {
      fill: "#ed893e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.33,189.21a.18.18,0,0,0-.2.13.17.17,0,0,0,.12.21,4.76,4.76,0,0,1,3.21,2.85.18.18,0,1,0,.34-.1,5,5,0,0,0-3.45-3.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.23,181.47a.33.33,0,0,0,.23.14,2.81,2.81,0,0,1,2.1,1.44.35.35,0,0,0,.64-.29,3.5,3.5,0,0,0-2.63-1.84.35.35,0,0,0-.4.29A.34.34,0,0,0,364.23,181.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.62,182.15a.33.33,0,0,0-.06.1.35.35,0,0,0,.19.46,3.48,3.48,0,0,0,3.2-.18.35.35,0,1,0-.39-.58,2.8,2.8,0,0,1-2.54.11A.35.35,0,0,0,371.62,182.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364,185.59a.26.26,0,0,1-.21-.11.25.25,0,0,1,.07-.35,5.06,5.06,0,0,1,1.55-.45,2,2,0,0,0-1.38-.52.25.25,0,0,1-.25-.25.23.23,0,0,1,.24-.25,2.3,2.3,0,0,1,2,1.09.24.24,0,0,1,0,.23.23.23,0,0,1-.18.13,6.88,6.88,0,0,0-1.74.43A.24.24,0,0,1,364,185.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.39,175.56a5.34,5.34,0,0,1,3-7.12c5.08-2.44,11.41-.59,13.85-1.45,0,0,.2-2.77,3.5-2.17s4.3,4.74,4.3,4.74.77-4.22,3.28-.92-.86,10.29-7.25,10.62S352.69,177.8,349.39,175.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.4,229.53c-2.6-8.06,2.78-12.76,2.78-12.76a8.29,8.29,0,0,1,.89.56C372.61,221.59,371.41,225.67,370.4,229.53Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379.17 406.52 393.46 402.45 394.62 405.7 380.51 409.17 379.17 406.52",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.25 405.7 310.57 401.52 311.41 404.55 297.43 408.24 296.25 405.7",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.66,223.61l2.52-.19a3,3,0,0,1,2.47,1.06l2.83,3.42a5.46,5.46,0,0,1,1.07,4.9l-.28,1.06c-4.16.59-9.08-1.83-9.08-1.83l-1.48-.54a2.45,2.45,0,0,1-1.55-3.11l1-2.95A2.8,2.8,0,0,1,326.66,223.61Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374,224.53c-3.73,9-8.83,17.48-16,24.23-9.11,7.27-23.08-10.69-27.91-17.25a2.56,2.56,0,0,1,3.75-3.4c3.5,3,7.17,6.12,10.89,8.83,2.49,1.77,5.12,3.69,7.83,4.4.89.15.35-.17-.29.22l-.76.61a56.7,56.7,0,0,0,3.8-4.79,103.74,103.74,0,0,0,9.17-16.66c2.75-6.15,11.77-2.53,9.52,3.81Z",
    style: {
      fill: "#e9b376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.59,219.88c-2.84,3.85-10.21,16.18-10.21,16.18s10.19,4.64,17.36,3c0,0,6.5-10.6,8.26-14.35,1.36-2.9,3.44-9.27-1.73-12.7C372.88,209.05,365.94,216.71,363.59,219.88Z",
    style: {
      fill: "#407BFF"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenericError);
export default __webpack_public_path__ + "static/media/GenericError.854b76da0d702072cd1399694ec9b16f.svg";
export { ForwardRef as ReactComponent };